export default {
  API_BASE_URL: 'https://account.proofapi.com',
  ALGOLIA_ACCOUNT_INDEX: 'accounts'
}



// WEBPACK FOOTER //
// ./src/api/config.js